/**
 * The case workspace has no backend behind it.
 *
 * Every figure on these five tabs comes from `services/store.ts`. On a
 * deployed URL that is indistinguishable from a real portfolio unless the page
 * says otherwise, and a fabricated DSCR mistaken for a real one is the most
 * damaging thing this product could do. So it says so, on every tab, and does
 * not offer a way to dismiss it.
 *
 * Delete this component when the underwriting endpoints exist — see
 * `docs/backend-compatibility-plan.md`.
 */
export function SampleDataBanner() {
  return (
    <div
      role="status"
      className="border-b border-caution/20 bg-caution-soft px-6 py-2 text-xs text-caution"
    >
      <span aria-hidden className="mr-1.5">
        ⚠
      </span>
      <span className="font-medium">Sample case.</span> The underwriting API does not exist yet,
      so every figure on this case is fabricated demonstration data. Changes are held in memory
      and are lost on reload.
    </div>
  );
}
